// Mock data for NexTI Connect Portal

export const mockServices = [
  {
    id: 1,
    number: '01',
    title: 'Infraestrutura de rede e Datacenters',
    description: 'Planejamento, implantação e otimização de ambientes de rede física e lógica. Criamos estruturas robustas, seguras e prontas para crescer junto com seu negócio.',
    icon: 'Server',
    color: 'blue'
  },
  {
    id: 2,
    number: '02',
    title: 'Cibersegurança',
    description: 'Firewalls de última geração, prevenção contra ataques cibernéticos, controle de acessos e políticas de proteção de dados. Segurança sob medida para seu ambiente.',
    icon: 'Shield',
    color: 'purple'
  },
  {
    id: 3,
    number: '03',
    title: 'Conectividade',
    description: 'Soluções de WLAN, VPN, redes corporativas e comunicação entre filiais. A NexTI garante estabilidade, velocidade e segurança para sua conexão.',
    icon: 'Wifi',
    color: 'cyan'
  },
  {
    id: 4,
    number: '04',
    title: 'Monitoramento Zabbix',
    description: 'Especialistas em Zabbix, oferecemos monitoramento inteligente de servidores, redes e aplicações. Antecipe falhas, otimize recursos e ganhe controle em tempo real.',
    icon: 'Monitor',
    color: 'blue'
  },
  {
    id: 5,
    number: '05',
    title: 'Nuvem & Backup',
    description: 'Implantação e gestão de soluções em nuvem, com backups automáticos e recuperação de desastres. Seus dados sempre protegidos, disponíveis e seguros.',
    icon: 'Cloud',
    color: 'purple'
  }
];

export const mockDiferenciais = [
  {
    id: 1,
    title: 'Equipe Técnica Especializada',
    description: 'Profissionais certificados com experiência comprovada em soluções de alta complexidade.',
    icon: 'Users'
  },
  {
    id: 2,
    title: 'Atendimento Consultivo',
    description: 'Apoio personalizado para entender suas necessidades e entregar a solução ideal.',
    icon: 'MessageSquare'
  },
  {
    id: 3,
    title: 'Parcerias Estratégicas',
    description: 'Trabalhamos com os principais fabricantes e fornecedores de tecnologia do mercado.',
    icon: 'Handshake'
  },
  {
    id: 4,
    title: 'Experiência em Alta Complexidade',
    description: 'Projetos desafiadores são nossa especialidade. Transformamos complexidade em simplicidade.',
    icon: 'Award'
  }
];

export const mockTickets = [
  {
    id: 1,
    title: 'Problema de conectividade',
    description: 'Internet lenta no escritório',
    status: 'novo',
    priority: 'alta',
    client: 'Empresa ABC',
    createdAt: '2024-01-15'
  },
  {
    id: 2,
    title: 'Backup não está funcionando',
    description: 'Sistema de backup retornando erro',
    status: 'em_andamento',
    priority: 'media',
    client: 'Empresa XYZ',
    createdAt: '2024-01-14'
  }
];

export const mockUsers = [
  {
    id: 1,
    name: 'Admin User',
    email: 'admin@nexti.com.vc',
    role: 'admin',
    client: 'NexTI'
  },
  {
    id: 2,
    name: 'Técnico João',
    email: 'joao@nexti.com.vc',
    role: 'tecnico',
    client: 'NexTI'
  }
];

export const mockClients = [
  { id: 1, name: 'Empresa ABC', email: 'contato@abc.com', phone: '(12) 3042-1708' },
  { id: 2, name: 'Empresa XYZ', email: 'contato@xyz.com', phone: '(12) 3042-1709' }
];

export const contactInfo = {
  email: 'contato@nexti.com.vc',
  phone: '(12) 3042-1708',
  whatsapp: '(12) 3042-1708',
  address: 'São Paulo, SP - Brasil'
};